import * as React from "react";

const DashboardPagingContext = React.createContext<{ pageSize: number; setPageSize: (value: number) => void } | undefined>(undefined);

export const DashboardPagingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [pageSize, setPageSize] = React.useState(20);
    const value = React.useMemo(() => ({ pageSize, setPageSize }), [pageSize]);
    return <DashboardPagingContext.Provider value={value}>{children}</DashboardPagingContext.Provider>;
};

export function useDashboardPaging() {
    const context = React.useContext(DashboardPagingContext);
    if (!context) throw new Error("useDashboardPaging must be used within DashboardPagingProvider");
    return context;
}
